<div class="content-body m-3" [formGroup]="form">
    <div class="row m-3">
        <div class="col-12 text-center">
            <h4>Customer Profile</h4>
        </div>
    </div>
    <div class="row m-2">
        <div class="col-12 text-center">
            <input type="radio" id="Person" name="CustomerType" (change)="CustomerTypeChange($event.target)">
            <label>บุคคลธรรมดา</label> &nbsp;
            <input type="radio" id="Company" name="CustomerType" checked (change)="CustomerTypeChange($event.target)">
            <label>นิติบุคคล</label>
        </div>
    </div>

    <div class="row centered-content" id="divNonIndividual">
        <div class="col-12 col-lg-10">
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">ประเภทลูกค้า</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control selectCompany" id="Type_Company" style="width: 100%;">
                                <option *ngFor="let sd of CompanyTypeList" [value]="sd.dpa_companytypeid">
                                    {{sd.dpa_name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">ชื่อนิติบุคคล</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="dpa_companyname">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label id="LabelRegID">เลขประจำตัวผู้เสียภาษี / เลขนิติบุคคล</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="dpa_registrationid" (keypress)="NumericKey($event)">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">เลขที่บัญชี</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="AccountNo_Company" (keypress)="NumericKey($event)" maxlength="13">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">E-Mail หลัก</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="EMail_Company">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">ชื่อผู้รับมอบอำนาจ</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="AuthorizedFirstName">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">นามสกุลผู้รับมอบอำนาจ</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="AuthorizedLastName">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">เลขบัตรประชาชน</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="dpa_authorizedperson_idcard" (keypress)="NumericKey($event)" maxlength="13">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">หมายเลขโทรศัพท์</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="dpa_authorizedperson_telephone" (keypress)="TelephoneKey($event)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END divNonIndividual -->

    <div class="row centered-content hidden" id="divIndividual">
        <div class="col-12 col-lg-10">
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">ประเภทลูกค้า</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control selectPerson" id="Type_Person" style="width: 100%;">
                                <option *ngFor="let sd of PersonTypeList" [value]="sd.dpa_personaltypeid">
                                    {{sd.dpa_name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">ชื่อ</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="firstname">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">นามสกุล</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="lastname">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label id="LabelBirthDate">วัน เดือน ปีเกิด</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="birthdate" data-provide="datepicker"
                                data-date-language="th-th" placeholder="วัน/เดือน/ปี (ปี พ.ศ. เช่น 15/04/2501)">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required" id="IdCardOrPassport">เลขบัตรประชาชน</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="dpa_idcard" formControlName="dpa_idcard" maxlength="13">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">เลขที่บัญชี</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="AccountNo_Person" (keypress)="NumericKey($event)" maxlength="13">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">E-Mail หลัก</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" id="EMail_Person">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">หมายเลขโทรศัพท์</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="telephone1" id="telephone1" (keypress)="TelephoneKey($event)">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                </div>
            </div>
        </div>
    </div>
    <!-- END divIndividual -->

    <div class="row m-3">
        <div class="col-12 text-center">
            <h4>ที่อยู่สามารถติดต่อได้</h4>
        </div>
    </div>

    <div class="row centered-content">
        <div class="col-12 col-lg-10">
            <div class="row m-2">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label class="required">เลขที่</label>
                        </div>
                        <div class="col-md-10">
                            <input type="text" class="form-control" formControlName="dpa_contact_homeno">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label>หมู่ที่</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="dpa_contact_moo">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label>ถนน</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" formControlName="dpa_contact_street">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label class="required">ค้นหาที่อยู่ของคุณ</label>
                        </div>
                        <div class="col-md-10">
                            <select class="form-control selectAddress" style="width: 100%;" id="SelectAddress">
                                <option value="">เลือก</option>
                                <option *ngFor="let sd of AddressList" [value]="sd.id">
                                    {{sd.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">ตำบล/แขวง</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" readonly
                                formControlName="dpa_contact_subdistictname">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">อำเภอ/เขต</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" readonly formControlName="dpa_contact_distictname">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">จังหวัด</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" readonly formControlName="dpa_contact_provincename">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">รหัสไปรษณีย์</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" readonly formControlName="dpa_contact_postcodename">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label>ประเทศ</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" readonly formControlName="dpa_contact_countryname">
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                </div>
            </div>
        </div>
    </div>
    <!-- END Address -->

    <br />
    <!-- Document List -->
    <div class="row centered-content">
        <div class="col-11 col-md-6" id="divDocList">
        </div>
    </div>
    <!-- End Document List -->

    <!-- Upload-->
    <div class="row centered-content" id="divUpload">
        <div class="col-md-8 m-4">
            <div class="upload-btn-wrapper" style="width: 100px; cursor: pointer;">
                <!-- <input type="text" id="txtFileName" class="form-control" placeholder="เลือกไฟล์..."> -->
                <button class="btn btn-default"><i class="fas
                    fa-plus"></i>
                &nbsp;Upload</button>
                <input type="file" id="fileAttach" [accept]="AcceptExtension" (change)="FileSelect($event.target.files)" style="cursor: pointer;" />
            </div>
            <!-- <button class="btn btn-default" (click)="UploadFile()"><i class="fas
                    fa-upload"></i>
                &nbsp;Upload</button> -->
        </div>
    </div>

    <div class="row centered-content">
        <div class="col-md-8">
            <table id="TableDocs" style="width: 100%;" class="table
                table-bordered table-hover table-responsive-sm result-table
                display nowrap">
                <thead class="hidden">
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
    <div class="row centered-content mt-4">
        <div class="col-11 col-md-6">
            <label class="checktable">
                <input type="checkbox" id="ReceiveNews"><span class="checkmark"></span>
                <label>ต้องการรับโฆษณาและข่าวสารประชาสัมพันธ์จากสถาบันคุ้มครองเงินฝาก</label>
            </label>
            <label class="checktable">
                <input type="checkbox" id="Accepted" (change)="AcceptChange()"><span class="checkmark"></span>
                <label>ยอมรับนโยบายความเป็นส่วนตัว</label>
                <!-- <button class="btn btn-link" (click)="ShowConsent()">เรียนรู้เพิ่มเติม</button> -->
            </label>
        </div>
    </div>
</div>
<br />
<div class="row">
    <div class="col-12 centered-content">
        <button class="btn btn-default" (click)="Send()" [disabled]="!AcceptChecked">ส่งข้อมูล</button> &nbsp;
        <button class="btn btn-default" (click)="GoBackHome()">กลับสู่หน้าหลัก</button>
    </div>
</div>
<br />

<div class="modal fade" id="dlgAcceptCondition" tabindex="-1" role="dialog" aria-labelledby="consentModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="consentModalLabel">นโยบายความเป็นส่วนตัว</h5>
      </div>
      <div class="modal-body">

        <div class="row border rounded">
          <div class="col-12 text-center">
            <label>นโยบายความเป็นส่วนตัว (Privacy Policy)</label>
          </div>
          <div class="col-12 mt-3">
            <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ
              จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ. 2551
              ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ. ขอขอบคุณสำหรับความไว้วางใจจากท่าน
              และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล</label>
            <br>
            <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy)
              เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล การเก็บรักษาข้อมูลไว้เป็นความลับ
              รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ
              โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy Policy)</label>
          </div>
          <div class="col-12 mt-3">
            <label>ขอแสดงความนับถือ</label>
          </div>
          <div class="col-12">
            <label>สถาบันคุ้มครองเงินฝาก</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container centered-content">
    <div class="modal" id="dlgFile" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="width: 100vw; height: 100vh; position: fixed; top: 0px; left: 0px;
                overflow-y: auto;">
                <div class="modal-header">
                    <h4 class="modal-title" id="FileNameTitle" style="padding-left: 10px;">File</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin-right: 10px;">
                        <span aria-hidden="true">X</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <div class="row">
                        <div class="col-12 centered-content">
                            <iframe width="95%" style="height: 90vh;" id="ViewDocFrame" class="centered-content"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/profile-register/profile-register.component.html